(() => {
  'use strict';

  const state = window.PatiPelloV10 || {
    bound: false,
    purchaseVisible: false,
    footerVisible: false,
    observer: null,
    footerObserver: null
  };

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getHeaderOffset = () => {
    const header = document.querySelector('sticky-header, .header-wrapper, [data-header-section]');
    return header ? Math.ceil(header.getBoundingClientRect().height) + 14 : 14;
  };

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const focusPurchaseControl = (target) => {
    const container = target.closest('.product__info-container') || target.parentElement || document;
    const candidates = container.querySelectorAll(
      '.product-form__input input:not([disabled]), [data-pp-package-option], .product-form__submit:not([disabled]), button[name="add"]:not([disabled])'
    );
    const focusTarget = Array.from(candidates).find(isVisible);
    if (!focusTarget) return;
    window.setTimeout(() => focusTarget.focus({ preventScroll: true }), reduceMotion() ? 0 : 420);
  };

  const scrollToPurchase = () => {
    const target = document.getElementById('patipello-purchase-area');
    if (!target) return;
    const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - getHeaderOffset());
    window.scrollTo({ top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    target.classList.remove('is-pp-v10-highlight');
    void target.offsetWidth;
    target.classList.add('is-pp-v10-highlight');
    window.setTimeout(() => target.classList.remove('is-pp-v10-highlight'), 1500);
    focusPurchaseControl(target);
  };

  const updateSticky = () => {
    document.querySelectorAll('[data-pp-mobile-sticky]').forEach((sticky) => {
      const shouldShow = window.scrollY > 180 && !state.purchaseVisible && !state.footerVisible;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  };

  const observeStickyConditions = () => {
    if (state.observer) state.observer.disconnect();
    if (state.footerObserver) state.footerObserver.disconnect();

    const purchase = document.getElementById('patipello-purchase-area');
    if (purchase) {
      const purchaseContainer = purchase.closest('.product__info-container') || purchase.parentElement;
      const observedPurchaseNodes = [purchase];
      if (purchaseContainer) {
        observedPurchaseNodes.push(...purchaseContainer.querySelectorAll('variant-selects, variant-radios, .product-form__input, .product-form__buttons'));
      }
      const purchaseNodeVisibility = new Map(observedPurchaseNodes.map((node) => [node, false]));
      state.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => purchaseNodeVisibility.set(entry.target, entry.isIntersecting));
        state.purchaseVisible = Array.from(purchaseNodeVisibility.values()).some(Boolean);
        updateSticky();
      }, { threshold: 0.08, rootMargin: '-70px 0px -25% 0px' });
      observedPurchaseNodes.forEach((node) => state.observer.observe(node));
    }

    const footer = document.querySelector('footer, .footer');
    if (footer) {
      state.footerObserver = new IntersectionObserver((entries) => {
        state.footerVisible = entries.some((entry) => entry.isIntersecting);
        updateSticky();
      }, { threshold: 0, rootMargin: '0px 0px 140px 0px' });
      state.footerObserver.observe(footer);
    }

    updateSticky();
  };

  const syncDetailsAria = (scope = document) => {
    scope.querySelectorAll('.pp-v10-faq details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  };

  const bind = () => {
    if (!state.bound) {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-pp-purchase-scroll]');
        if (!trigger) return;
        event.preventDefault();
        scrollToPurchase();
      });

      document.addEventListener('toggle', (event) => {
        if (!(event.target instanceof HTMLDetailsElement) || !event.target.closest('.pp-v10-faq')) return;
        const summary = event.target.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', event.target.open ? 'true' : 'false');
      }, true);

      window.addEventListener('scroll', updateSticky, { passive: true });
      state.bound = true;
    }

    syncDetailsAria();
    observeStickyConditions();
  };

  document.addEventListener('DOMContentLoaded', bind, { once: true });
  document.addEventListener('shopify:section:load', (event) => {
    syncDetailsAria(event.target);
    observeStickyConditions();
  });

  window.PatiPelloV10 = state;
})();
